import React from 'react'

import Text, { type TextProps } from './Text'

type ExternalLinkProps = {
  href: string
  onClick?: () => void
} & TextProps

const ExternalLink = React.forwardRef<React.Ref<any>, ExternalLinkProps>(
  ({ href, ...rest }, ref: React.Ref<any>) => {
    const formattedLink = href.startsWith('http') ? href : `//${href}`

    return (
      <Text
        ref={ref}
        as="a"
        href={formattedLink}
        rel="noopener noreferrer nofollow"
        target="_blank"
        {...rest}
      />
    )
  }
)

ExternalLink.displayName = 'ExternalLink'

export default ExternalLink
